import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resetBtn"]

  connect() {
    this.activeFilters = {
      cost: [],
      rarity: [],
      card_type: [],
      origin: []
    }
    this.restoreFromUrl()
  }

  restoreFromUrl() {
    const url = new URL(window.location.href)

    ;["cost", "rarity", "card_type", "origin"].forEach(type => {
      const values = url.searchParams.getAll(`${type}[]`)
      this.activeFilters[type] = values

      values.forEach(value => {
        const btn = this.element.querySelector(`[data-filter-type="${type}"][data-filter-value="${value}"]`)
        if (btn) btn.classList.add("filter-btn-active")
      })
    })

    this.updateResetBtn()
  }

  toggle(event) {
    const btn = event.currentTarget
    const type = btn.dataset.filterType
    const value = btn.dataset.filterValue

    const index = this.activeFilters[type].indexOf(value)
    if (index === -1) {
      this.activeFilters[type].push(value)
      btn.classList.add("filter-btn-active")
    } else {
      this.activeFilters[type].splice(index, 1)
      btn.classList.remove("filter-btn-active")
    }

    this.updateResetBtn()
    this.submit()
  }

  reset() {
    this.activeFilters = { cost: [], rarity: [], card_type: [], origin: [] }
    this.element.querySelectorAll(".filter-btn-active").forEach(btn => btn.classList.remove("filter-btn-active"))
    this.updateResetBtn()
    this.submit()
  }

  submit() {
    const form = document.getElementById("card-filter-form")
    if (!form) return

    // Clear existing filter inputs
    form.querySelectorAll("input[data-filter-input]").forEach(i => i.remove())

    // Add current filter values
    Object.entries(this.activeFilters).forEach(([type, values]) => {
      values.forEach(value => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = `${type}[]`
        input.value = value
        input.dataset.filterInput = true
        form.appendChild(input)
      })
    })

    form.requestSubmit()
  }

  updateResetBtn() {
    const hasActive = Object.values(this.activeFilters).some(arr => arr.length > 0)
    if (this.hasResetBtnTarget) {
      this.resetBtnTarget.classList.toggle("filter-reset-active", hasActive)
    }
  }
}
